import { render, staticRenderFns } from "./Contacts_edit.vue?vue&type=template&id=4d261658&"
import script from "./Contacts_edit.vue?vue&type=script&lang=js&"
export * from "./Contacts_edit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports